import { Component } from 'react';
import { connect } from 'react-redux';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { config } from '../utils/constants/api.constants';
import { getUserData, redirectPage } from '../utils/utils';
import BarScan from './images/barscan.png';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      claims: { country: [], vehicleType: [] },
      country: '',
      vehicleType: '',
      isMenuActive: false,
    };
    this.logout = this.logout.bind(this);
    this.userDataCheckInterval = null;
    this.userDataCheckTimeout = null;
  }

  componentDidMount() {
    const userData = getUserData();
    const accessToken = localStorage.getItem('accessToken');

    if (!accessToken) {
      this.logout();
      return;
    }

    if (userData) {
      this.googleApi();
      this.setState({ userData: userData });
      this.updateClaimsFromUserData(userData);
    } else {
      this.userDataCheckInterval = setInterval(() => {
        const data = getUserData();
        if (data) {
          this.setState({ userData: data });
          this.updateClaimsFromUserData(data);
          clearInterval(this.userDataCheckInterval);
          clearTimeout(this.userDataCheckTimeout);
          this.userDataCheckInterval = null;
          this.userDataCheckTimeout = null;
        }
      }, 100);

      this.userDataCheckTimeout = setTimeout(() => {
        if (this.userDataCheckInterval) {
          clearInterval(this.userDataCheckInterval);
          this.userDataCheckInterval = null;
        }
      }, 5000);
      this.googleApi();
    }

    const country = localStorage.getItem('country');
    const vehicleType = localStorage.getItem('vehicleType');

    if (!country) {
      // this.setState({ country: 'IN' });
      // localStorage.setItem('country', 'IN');
    } else {
      this.setState({ country });
    }

    if (!vehicleType) {
      this.setState({ vehicleType: 'CAR' });
      localStorage.setItem('vehicleType', 'CAR');
    } else {
      this.setState({ vehicleType });
    }
  }

  componentWillUnmount() {
    if (this.userDataCheckInterval) {
      clearInterval(this.userDataCheckInterval);
      this.userDataCheckInterval = null;
    }
    if (this.userDataCheckTimeout) {
      clearTimeout(this.userDataCheckTimeout);
      this.userDataCheckTimeout = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.userData !== this.state.userData && this.state.userData) {
      this.updateClaimsFromUserData(this.state.userData);
    }

    const currentCountry = localStorage.getItem('country');
    const currentVehicleType = localStorage.getItem('vehicleType');

    if (currentCountry && currentCountry !== this.state.country) {
      this.setState({ country: currentCountry });
    }
    if (currentVehicleType && currentVehicleType !== this.state.vehicleType) {
      this.setState({ vehicleType: currentVehicleType });
    }
  }

  updateClaimsFromUserData = (userData) => {
    const assignedVehicleTypes = userData?.vehicleType || ['CAR'];
    const assignedCountries = userData?.country || ['IN'];

    this.setState({
      claims: {
        country: assignedCountries,
        vehicleType: assignedVehicleTypes,
      },
    });
  };

  googleApi = () => {
    if (!window.google?.maps) {
      const googleMapScript = document.createElement('script');
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${config.api.google.googleKey}&libraries=places`;
      googleMapScript.async = true;
      window.document.body.appendChild(googleMapScript);
    }
  };

  changeCountry = (e) => {
    let newCountry = e.value;
    localStorage.setItem('country', newCountry);
    sessionStorage.removeItem('searchLocations');
    sessionStorage.removeItem('searchMasterData');
    sessionStorage.removeItem('searchCity');
    sessionStorage.removeItem('searchState');
    sessionStorage.removeItem('searchZone');
    sessionStorage.removeItem('searchInventories');
    sessionStorage.removeItem('inventoryLocation');
    localStorage.removeItem('inventory-grid-columns');
    localStorage.removeItem('logistics-grid-columns');
    var currentQueryString = window.location.search;
    redirectPage(currentQueryString);
  };

  changeVehicleType = (e) => {
    let newVehicleType = e.value;
    localStorage.setItem('vehicleType', newVehicleType);
    sessionStorage.removeItem('searchLocations');
    sessionStorage.removeItem('searchMasterData');
    sessionStorage.removeItem('searchCity');
    sessionStorage.removeItem('searchState');
    sessionStorage.removeItem('searchZone');
    sessionStorage.removeItem('searchInventories');
    sessionStorage.removeItem('inventoryLocation');
    localStorage.removeItem('inventory-grid-columns');
    localStorage.removeItem('logistics-grid-columns');

    const currentQueryString = window.location.search;
    redirectPage(currentQueryString);
  };

  async logout() {
    if (this.props.onLogout) {
      await this.props.onLogout();
    }
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  }

  render() {
    return (
      <header className="headerSection">
        <div style={{ padding: '0px 15px' }}>
          <div style={{ display: 'flex' }}>
            <div className="typeSelect">
              <div style={{ display: 'flex' }}>
                <div
                  id="nav_menu"
                  onClick={() => this.props.toggleMenu()}
                  style={{ paddingRight: '15px' }}
                >
                  <a href="#menu" id="toggle" className="">
                    <span> </span>
                  </a>
                </div>
                <div className="">
                  <DropDownList
                    data={this.state.claims.country}
                    onChange={(e) => this.changeCountry(e)}
                    value={this.state.country}
                    className="countryHeader"
                  />
                </div>
                <div className="">
                  <DropDownList
                    data={this.state.claims.vehicleType}
                    className="vehicleHeader"
                    onChange={(e) => this.changeVehicleType(e)}
                    value={this.state.vehicleType}
                  />
                </div>
              </div>
            </div>
            <div
              className="user-profile"
              style={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              {this.props.uiRulesData?.stockInBy && (
                <div
                  className="barName"
                  onClick={() => this.props.toggleBarCode()}
                >
                  <img src={BarScan} alt="icon" />
                </div>
              )}

              <div className="userName">
                <span className="userNameIn">
                  {' '}
                  {this.state.userData && this.state.userData.name}{' '}
                </span>
                <span className="k-icon k-i-arrow-chevron-down" />
                <ul className="userDropdown">
                  <li onClick={this.logout}> Logout</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  uiRulesData: state.inventoryManagementReducer.uiRulesData,
});

export default connect(mapStateToProps)(Header);

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
